import React from 'react'
import BRAND from 'brand'
import style from './style.module.scss'

function Footer() {
  return (
    <div className={style.footer}>
      <div className={style.footerInner}>
        <a
          href={BRAND.links.portal}
          target="_blank"
          rel="noopener noreferrer"
          className={style.logo}
        >
          PORTAL {BRAND.name.toUpperCase()}
        </a>
        <br />
        <p className="mb-0">
          Copyright © {new Date(Date.now()).getFullYear()} {BRAND.legalName} |{' '}
          <a href={BRAND.links.legal} target="_blank" rel="noopener noreferrer">
            Legal
          </a>
        </p>
      </div>
    </div>
  )
}

export default Footer
